import { Controller } from 'stimulus';
import jump from 'jump.js';

/**
 * Jump to target
 *
 * @class Jump
 * @extends {Controller}
 */
class Jump extends Controller {
  onJumpClick() {
    jump(this.data.get('target'), {
      a11y: true,
      offset: parseInt(this.data.get('offset'), 10) || 0,
      duration: parseInt(this.data.get('duration'), 10) || 1000,
    });
  }
}

Jump.targets = [
  //
];

export default Jump;
